import React from "react";
import { Outlet } from "react-router-dom";
import Layout from "../../layout/Layout";

const UserAccounts = () => {
  return (
    <div>
      <Layout>
        <Outlet />
      </Layout>
    </div>
  );
};

export default React.memo(UserAccounts);
